export default {"src":"/_next/static/media/logo-europcar.c0154789.svg","height":15,"width":59,"blurWidth":0,"blurHeight":0};